import { render, staticRenderFns } from "./LogoBlock.vue?vue&type=template&id=fcce9fa6&scoped=true"
import script from "./LogoBlock.vue?vue&type=script&lang=js"
export * from "./LogoBlock.vue?vue&type=script&lang=js"
import style0 from "./LogoBlock.vue?vue&type=style&index=0&id=fcce9fa6&prod&scoped=true&lang=scss"
import style1 from "./LogoBlock.vue?vue&type=style&index=1&id=fcce9fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcce9fa6",
  null
  
)

export default component.exports